import React, { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Table, Col, Row, Nav, Container, Button, Spinner } from "@/Components/Common/Tailwind";
import { API, BACKEND_HOST } from "../../../api";
import Navbar from "../../../Components/Common/navbar";
import { getAccessToken } from "../../../api/auth";
import { SUBDOMAIN } from "../../../assets/meta/meta";
import { useInfiniteQuery } from "@tanstack/react-query";
import QueryString from "qs";
import moment from "moment";
import MobileViewContainer from "../../../Components/MobileViewContainer";

// Shared components
import { LoadingSpinner, EmptyMessage } from "../../../Components/Common";
import { formatDate } from "../../../utils/formatters";

const CancelList = () => {
  const navigate = useNavigate();

  // const [cancels, setCancels] = React.useState([]);
  const [dataQueryString, setDataQueryString] = useState({
    filter_site: SUBDOMAIN,
  });

  const token = getAccessToken();

  const fetchData = useCallback(
    async (page) => {
      if (!token) {
        throw new Error("로그인이 필요합니다.");
        // navigate(`/`);
      }
      let _queryString = QueryString.stringify(dataQueryString);
      if (_queryString) {
        _queryString = `&${_queryString}`;
      } else {
        _queryString = "";
      }
      const response = await API.get(`/package/user-cancel-app/?page=${page}${_queryString}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      return response.data;
    },
    [token, dataQueryString]
  );

  const {
    status, data, error, isSuccess, isFetching, isLoading, isFetchingNextPage, isFetchingPreviousPage, fetchNextPage, fetchPreviousPage, hasNextPage, hasPreviousPage, refetch
  } = useInfiniteQuery({
    queryKey: ["cancel-list", dataQueryString],
    queryFn: ({ pageParam = 1 }) => fetchData(pageParam),
    getNextPageParam: (lastPage) => (lastPage.hasMore ? lastPage.page + 1 : undefined),
  });



  return (
    <React.Fragment>
      <MobileViewContainer>
        <Navbar />
        <Container fluid style={{ minHeight: "100vh", backgroundColor: "white", paddingBottom: "100px" }}>
          <Row className="justify-center">
            <Col xxl={12} xl={12} md={12} sm={12}>
              <div className="table-responsive">

                {isLoading && <LoadingSpinner height="150px" />}

                {status === "error" && (
                  <EmptyMessage message="취소 내역을 불러올 수 없습니다. 잠시 후 다시 시도해 주세요." height="150px" />
                )}

                {isSuccess && data.pages.flatMap((p) => p.results).length === 0 && (
                  <EmptyMessage message="취소 내역이 없습니다." height="150px" />
                )}

                {isSuccess && (
                  <>
                    {data.pages.map((page, index) => (
                      <React.Fragment key={index}>
                        {page.results.map((item) => (
                          <div key={item.id} style={{ border: "1px solid #ededed", padding: "20px", borderRadius: "5px" }} className="mt-3 pb-0">
                            <div>
                              <p style={{ fontSize: "15px", fontWeight: "600", paddingBottom: "15px", borderBottom: "1px solid #ededed" }}>{item.name} #{item.id}</p>

                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid #ededed", marginBottom: "15px" }}>
                                <p style={{ color: "#6d6d6d" }}>취소일</p>
                                <p>{moment(item.cancelDate).format("YYYY-MM-DD")}</p>
                              </div>

                              <div>
                                {item.reservationDate ? (
                                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid #ededed", marginBottom: "15px" }}>
                                    <p style={{ color: "#6d6d6d" }}>예약일</p>
                                    <p>{item.reservationDate}</p>
                                  </div>
                                ) : null}
                                {item.spot ? (
                                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px solid #ededed", marginBottom: "15px" }}>
                                    <p style={{ color: "#6d6d6d" }}>예약 좌석</p>
                                    <p>{item.spot}번</p>
                                  </div>
                                ) : null}
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "15px" }}>
                                  <p style={{ color: "#6d6d6d" }}>취소금액</p>
                                  <p>{item.cancelAmount.toLocaleString()}원</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </React.Fragment>
                    ))}
                  </>
                )}

                {isFetchingNextPage && <LoadingSpinner height="80px" />}

                <div className="flex justify-center gap-3" style={{ alignItems: "center", height: 50 }}>
                  {hasNextPage ? (
                    <Button variant="secondary" onClick={() => fetchNextPage()}>
                      다음
                    </Button>
                  ) : null}
                </div>

              </div>
            </Col>
          </Row>
        </Container>
      </MobileViewContainer>
    </React.Fragment>
  );
};
export default CancelList;
